export const environment = {
  production: false,
  apiUrl: 'https://api-dev-foyer.infano.io',
  auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_lezlm3z3O',
    webClientId: '2patq2rok198nv2ke38079fthq',
  },
};
